import { hbs } from 'ember-cli-htmlbars';
export default hbs("  {{#if this.isResizable}}\n    <div class=\"et-header-resize-area\">\n    </div>\n  {{/if}}")